import { AxiosResponse } from "axios";
import HttpService from "./http-service";
import Paginated from "./paginated";
import ApiPaginated from "./paginated";
export default class DocumentationGroupService extends HttpService {
  public getDocumentationGroups(): Promise<
    AxiosResponse<Paginated<DocumentationGroup>>
  > {
    return this.httpClient.get<Paginated<DocumentationGroup>>(
      "/documentation_groups",
      { params: { with_documentations: true } }
    );
  }

  public getAllDocumentationGroups(): AsyncIterable<DocumentationGroup[]> {
    const httpClient = this.httpClient;
    return {
      [Symbol.asyncIterator](): AsyncIterator<DocumentationGroup[]> & {
        lastPage: null | number;
        currentPage: number;
      } {
        return {
          currentPage: 0,
          lastPage: null as null | number,
          async next(): Promise<IteratorResult<DocumentationGroup[]>> {
            this.currentPage = this.currentPage + 1;
            if (this.lastPage === null || this.currentPage <= this.lastPage) {
              const { data } = await httpClient.get<
                ApiPaginated<DocumentationGroup>
              >("/documentation_groups", {
                params: { with_documentations: true },
              });

              this.lastPage = data.last_page;
              return {
                done: false,
                value: data.data,
              };
            }
            return { done: true, value: undefined };
          },
        };
      },
    };
  }

  public getDocumentationGroup(
    id: string
  ): Promise<AxiosResponse<DocumentationGroup>> {
    return this.httpClient.get<DocumentationGroup>(
      `/documentation_groups/${id}`
    );
  }
}

export interface DocumentationGroup {
  id: number;
  name: string;
  index: string | number;
  documentations: Documentation[];
}

export interface Documentation {
  id: number;
  index: string | number;
  name: string;
  description: string;
}

export interface Entity {
  id: number;
  name: string;
  acronym: string;
  entity_type_id: number;
}
